import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchTopicsComponent } from './research-topics.component';
const routes: Routes = [
  {
    path: '',
    component: ResearchTopicsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResearchTopicRoutingoModule { }